import { getWindowLocationHostname } from './index'

/* istanbul ignore next */
export function unsubscribeFromAllChannelsWithPrefix(connection, prefix) {
  Object.keys(connection.channels.channels).forEach(c => {
    if (c.indexOf(prefix) > -1) {
      connection.unsubscribe(c)
    }
  })
}

/* istanbul ignore next */
export const getPusherApiKey = () => {
  // TODO: base this off config/build
  let key = '602419600735c6d08968'

  switch (getWindowLocationHostname()) {
    case 'questmaker.questforward.org':
      key = '5cfd179ce9fb5571d06b'
      break
  }

  return key
}

export const getQwPusherApiKey = () => {
  // TODO: base this off config/build
  let key = '71f27384a152ea6e8247'

  switch (getWindowLocationHostname()) {
    case 'questmaker.questforward.org':
      key = '86a3eebe83cbf2cfd44c'
      break
  }

  return key
}

export function hasNeededPusherConnection(pusher) {
  return pusher && pusher.connection && pusher.connection.state === 'connected'
}



// WEBPACK FOOTER //
// ./src/utils/pusher.js